import { videoUrl } from '@helpers/cloudinary';
import { imageUrl } from '@helpers/image';
import { isMediaVideo } from '@helpers/video';
import { ReactComponent as ArrowLeft } from '@img/icons/nav-arrow-left.svg';
import { ReactComponent as ArrowRight } from '@img/icons/nav-arrow-right.svg';
import { AnimatePresence } from 'framer-motion';
import * as React from 'react';
import { useSwipeable } from 'react-swipeable';
import Modal from '../Modal/Modal';
import S from './ModalGallery.styles';
import { useModalGalleryContext } from './ModalGalleryProvider/ModalGalleryProvider';
const ModalGallery = (props) => {
    const { children, media, openIndex, ...rest } = props;
    if (!media) {
        return null;
    }
    const modalGallery = useModalGalleryContext();
    const activeItem = media[modalGallery.activeIndex];
    React.useEffect(() => {
        if (openIndex !== modalGallery.activeIndex) {
            modalGallery.goToIndex(openIndex);
        }
    }, [openIndex]);
    React.useEffect(() => {
        if (props.onIndexChange) {
            props.onIndexChange(modalGallery.activeIndex);
        }
    }, [modalGallery.activeIndex]);
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => {
            modalGallery.goToNext(false);
        },
        onSwipedRight: () => {
            modalGallery.goToPrev(false);
        },
    });
    if (!activeItem) {
        return null;
    }
    const variants = {
        hidden: { opacity: 0, scale: 0.65 },
        visible: { opacity: 1, scale: 1 },
    };
    const variantAttrs = {
        initial: 'hidden',
        animate: 'visible',
        exit: 'hidden',
        variants,
    };
    return (React.createElement(Modal, { ...rest },
        React.createElement(AnimatePresence, { exitBeforeEnter: true }, isMediaVideo(activeItem) ? (React.createElement(S.Video, { key: activeItem.videoId, autoPlay: true, controls: true, playsInline: true, poster: activeItem.previewImage
                ? imageUrl(activeItem.previewImage, { width: 1920, height: 1080 })
                : videoUrl(activeItem.videoId, { format: 'jpg' }), ...variantAttrs, ...swipeHandlers },
            React.createElement("source", { type: "video/webm", src: videoUrl(activeItem.videoId, { format: 'webm' }) }),
            React.createElement("source", { type: "video/mp4", src: videoUrl(activeItem.videoId, { format: 'mp4' }) }))) : (React.createElement(S.Image, { key: activeItem.src, src: imageUrl(activeItem, {}), alt: activeItem.altText ?? undefined, role: !activeItem.altText ? 'presentation' : undefined, ...variantAttrs, ...swipeHandlers }))),
        media.length > 1 && (React.createElement(React.Fragment, null,
            React.createElement(S.ControlButton, { "aria-label": "Previous", disabled: modalGallery.activeIndex === 0, type: "button", "data-variant": "prev", onClick: (event) => {
                    event.preventDefault();
                    modalGallery.goToPrev(false);
                } },
                React.createElement(ArrowLeft, null)),
            React.createElement(S.ControlButton, { "aria-label": "Next", disabled: modalGallery.activeIndex === modalGallery.maxIndex, type: "button", "data-variant": "next", onClick: (event) => {
                    event.preventDefault();
                    modalGallery.goToNext(false);
                } },
                React.createElement(ArrowRight, null)))),
        media.length > 0 ? (React.createElement(React.Fragment, null, media.map((item, i) => (React.createElement("link", { key: `modal-${i}-${isMediaVideo(item) ? item.videoId : item.src}`, rel: "preload", as: isMediaVideo(item) ? 'video' : 'image', href: isMediaVideo(item) ? videoUrl(item.videoId, { format: 'webm' }) : imageUrl(item, {}) }))))) : null));
};
export default ModalGallery;
